export default __webpack_public_path__ + "static/media/send-email-l.1bad13c9.svg";